export enum PaymentMilestoneStatusEnum {
	Active = 1,
	Inactive = 2,
	Draft = 3
}

export enum PaymentMilestoneCategoryTypeEnum {
	LocalServices = 1,
	Professional = 2,
	International = 3,
	Emergency = 4
}

export enum PaymentMilestoneStageReleaseConditionEnum {
	OnBooking = 1,
	OnServiceStart = 2,
	OnCompletion = 3,
	OnClientApproval = 4,
	OnTimeBased = 5
}

export enum DisputePeriodEnum {
	"24 hours" = 1,
	"48 hours" = 2,
	"72 hours" = 3,
	"7 days" = 4,
	"14 days" = 5,
	"30 days" = 6
}
